import { formatPattern } from "react-router-utils";
import Button from "app/components/UI/Button";
import Flex from "app/components/UI/Flex";
import Link from "app/components/UI/Link";
import Modal from "app/components/UI/Modal";
import PropTypes from "prop-types";
import React from "react";
import classes from "./ModalAddToCart.module.css";
import classnames from "classnames";

export const ModalAddToCart = ({ clubId, translate, className, children, ...props }) => (
  <Modal contentClassName={classnames(classes.modal, className)} bodyClassName={classes.modal__body} {...props}>
    <div className={classes.modal__title}>{translate("Votre produit à bien été ajouté au panier")}</div>
    <div className={classes.modal__content}>{children}</div>
    <Flex direction="row" middle right wrap className={classes.modal__actions}>
      <Link className={classes.modal__link__primary} to={formatPattern("/:clubId/checkout", { clubId: clubId })}>
        <Button.Flat fullWidth label={translate("Voir mon panier")} primary style={{ fontWeight: 700 }} />
      </Link>
      <Link className={classes.modal__link} to={formatPattern("/:clubId/shop", { clubId: clubId })}>
        <Button.Flat fullWidth label={translate("Continuer mes achats")} />
      </Link>
    </Flex>
  </Modal>
);

ModalAddToCart.propTypes = {
  clubId: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string
};

export default ModalAddToCart;



// WEBPACK FOOTER //
// ./src/app/components/ModalAddToCart/ModalAddToCart.js